<div class="flex w-full items-center gap-x-2">
    <div class="grow rounded-md bg-malou-dark" [style]="{ height: height() }">
        <div class="h-full rounded-md  {{ progressBarColorClass() }}" [style]="{ width: progressPercentage() }"></div>
    </div>
    @if (showPercentage()) {
        <div
            class="text-right"
            [ngClass]="{
                'malou-text-12--semibold w-[28px]': size() === LoaderProgressSize.MD || size() === LoaderProgressSize.LG,
                'malou-text-8--semibold w-[24px]': size() === LoaderProgressSize.SM,
            }">
            {{ progressPercentage() }}
        </div>
    }
</div>
